import { render } from "./GridZileDisponibilitate.vue?vue&type=template&id=2fb00a6b&scoped=true&ts=true"
import script from "./GridZileDisponibilitate.vue?vue&type=script&lang=ts"
export * from "./GridZileDisponibilitate.vue?vue&type=script&lang=ts"

import "./GridZileDisponibilitate.vue?vue&type=style&index=0&id=2fb00a6b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb00a6b"]])

export default __exports__